export const ReducerUtils = {
  partner: {
    details: "PARTNER_DETAILS",
  },
  product: {
    details: "PRODUCT_DETAILS",
    savingGrid: "PRODUCT_SAVING_GRID",
  },
  proposal: {
    list: "PROPOSAL_LIST",
    documents: "PROPOSAL_DOCUMENTS",
  },
  overview: {
    details: "OVERVIEW_DETAILS",
  },
  city: {
    list: "CITY_LIST",
  },
  state: {
    list: "STATE_LIST",
  },
  occupation: {
    list: "OCCUPATION_LIST",
  },
  bank: {
    list: "BANK_LIST",
  },
  mandate: {
    list: "MANDATE_LIST",
  },
  pincode: {
    list: "PINCODE_LIST",
    search: "PINCODE_SEARCH",
    result: "PINCODE_RESULT",
  },
  ifsc_code: {
    list: "IFSCODE_LIST",
  },
};
